import type { AssistantQuestion } from './types';

// Which panel is picked rather than the text it produces: an option whose label happens to match
// what someone typed into Other would otherwise be indistinguishable from it.
export type Selection = string | null;

export const OTHER = 'other';

export function getAnswer(question: AssistantQuestion, selection: Selection, other: string): string | null {
  if (selection === OTHER) {
    return other.trim() || null;
  }

  return selection === null ? null : question.options[Number(selection)]?.label || null;
}

export function replaceAt<T>(values: T[], index: number, value: T): T[] {
  return values.map((existing, position) => (position === index ? value : existing));
}
